import { FormVue } from "./index.js";

(window as any).FormVueInline = FormVue;

export { FormVue };
export type { FormVueInlineOptions } from "../shared/schema-types.js";
export type { InlineConfig, EmbedContext } from "../shared/types.js";
